export default "__VITE_ASSET__BcqnIlHO__"